import upperFirst from 'lodash/upperFirst';

export const prepareNameProp = (value) => upperFirst(`${ value }`.trim());
